export const config = {
  title: 'J Amaya Painting | Professional Painting Services in Des Moines, WA',
  meta: {
    description:
    'J Amaya Painting offers professional painting services in Des Moines, WA, specializing in residential, commercial, interior, and exterior painting projects.',
    keywords: [
      'J Amaya Painting',
      'Painting Services',
      'Residential Painting',
      'Commercial Painting',
      'Interior Painting',
      'Exterior Painting',
      'Des Moines WA',
      'MyBizSolutions',
      'MyBizSolutions LLC'
    ],
    author: 'J Amaya Painting',
    canonicalUrl: 'https://jamayapainting.com/',
  },
  sections: {
    header: {
      businessName: 'J Amaya Painting',
    },
    sectionB: {
      heroTitle: "J Amaya Painting",
      heroSubtitle: "Transforming Spaces with Professional Painting Services",
      learnAboutText: "Learn About Our Services",
      phoneNumber: "2065319635",
      phoneLabel: "(206) 531-9635",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1312114883/photo/mature-painter-painting-a-wall.jpg?s=612x612&w=0&k=20&c=t-afZ_AqE2YBkVrpc2VxAGtFfXpySDYrCOgLznO5cTk=",
      cardData: [
        {
          title: "Residential Painting",
          description:
            "Enhance your home's beauty with expert residential painting services.",
        },
        {
          title: "Commercial Painting",
          description:
            "Create a professional environment with top-quality commercial painting solutions.",
        },
        {
          title: "Interior Painting",
          description:
            "Revitalize your interior spaces with precision and care from our experienced painters.",
        },
      ],
      description:
        "J Amaya Painting provides premium residential, commercial, interior, and exterior painting services. Trust our skilled team to deliver high-quality finishes tailored to your specific needs.",
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
      'J Amaya Painting offers a variety of professional painting services designed to meet your specific needs. From residential to commercial projects, our team ensures exceptional results every time.',
      cards: [
        {
          title: 'Residential Painting',
          description:
            'Transform your home with vibrant, durable painting solutions.',
          imageSrc:
            'https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/QCYu6SDL6jQPe7CPKkAi/media/677c1c9c942a20134def184d.jpeg',
          imageAlt: 'Residential Painting',
        },
        {
          title: 'Commercial Painting',
          description:
            'Elevate your business with professional commercial painting services.',
          imageSrc:
            'https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/QCYu6SDL6jQPe7CPKkAi/media/677c1c9c942a209bd1ef184e.jpeg',
          imageAlt: 'Commercial Painting',
        },
        {
          title: 'Interior Painting',
          description:
            'Revamp your interiors with precision and style.',
          imageSrc:
            'https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/QCYu6SDL6jQPe7CPKkAi/media/677c1c9cd4ebc4f4c4ce9f20.jpeg',
          imageAlt: 'Interior Painting',
        },
      ],
      otherServicesTitle: 'Other Services',
      otherServicesList: [
        'Exterior Painting',
        'Custom Projects',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/QCYu6SDL6jQPe7CPKkAi/media/677c1d0431c890bccdfc5096.jpeg',
        alt: 'J Amaya Painting Team',
      },
      aboutText: [
        'J Amaya Painting has been a trusted name in painting services for over 10 years. Based in Des Moines, WA, we proudly serve both residential and commercial clients within a one-hour radius.',
        'Our experienced team is dedicated to transforming spaces with precision, care, and a commitment to excellence. Whether it’s a single room or an entire property, J Amaya Painting brings your vision to life with stunning results.',
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'J Amaya Painting Team',
      businessName: 'J Amaya Painting',
      contact: {
        phone: '2065319635',
        phoneLabel: '(206) 531-9635',
        email: 'jamayapainting@gmail.com',
        website: 'https://jamayapainting.com/',
        address: 'Des Moines, WA',
      },
      socialMedia: {
        googlePlus: null,
        linkedIn: null,
        facebook: null,
        twitter: null,
        tiktok: null,
        instagram: null,
        youtube: null,
      },
    },
    sectionF: {
      address: 'Des Moines, WA',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2887.5105881886655!2d-122.32401!3d47.40189!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x884039afdf85df3d%3A0x73dc541ee2fae5e0!2sDes%20Moines%2C%20WA!5e0!3m2!1sen!2sph!4v1614123456789!5m2!1sen!2sph',
    },
  },
};

export default config;